import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import { getApvPub, initConpay } from './apis';
import {
  clearStorage,
  initMessageEventListner,
  initialCommonEventListener,
  initialCommonPrototype,
  setReturnPromiseForBrand,
} from './helpers';
import { pushRouter, routes } from './router';
import './styles/custom.css';
import './styles/main.css';
import './styles/spin.css';
import { setDisableBackControl } from './utils/back-control';

class Conpay {
  constructor() {
    initialCommonPrototype();
    initialCommonEventListener();
    initMessageEventListner();
  }

  // 초기화
  init = async (data) => {
    let brandInfo = await getApvPub(`brandInfo?bid=${data.bid}`);
    // srvDivCode XYZ X=선불충전여부,Y=계좌결제여부,Z=카드결제여부, 1=여 OR 0=부
    const service = {
      charge: brandInfo.srvcDivCode.charAt(0) === '1',
      account: brandInfo.srvcDivCode.charAt(1) === '1',
      card: brandInfo.srvcDivCode.charAt(2) === '1',
    };
    brandInfo = {
      bid: brandInfo.bid,
      bndBizDivCode: brandInfo.bndBizDivCode,
      bndBizName: brandInfo.bndBizName,
      bndBizNo: brandInfo.bndBizNo,
      bndBizStatCode: brandInfo.bndBizStatCode,
      pushUrl: brandInfo.pushUrl,
      srvcDivCode: brandInfo.srvcDivCode,
      service,
    };

    clearStorage(data.userKey);

    try {
      await initConpay(data.userKey);

      sessionStorage.setItem('CONPAY_BRAND_INFO', JSON.stringify(brandInfo));
      sessionStorage.setItem('CONPAY_USER_KEY', data.userKey);
      sessionStorage.setItem('CONPAY_USER_EMAIL', data.userEmail || '');
      sessionStorage.setItem('CONPAY_REDIRECT_URL', data.redirectUrl);
      sessionStorage.setItem(
        'CONPAY_CUSTOMIZE_OPTION',
        JSON.stringify(data.style)
      );
    } catch (e) {
      console.log(e);
    }
    // getAccessToken(brandInfo, data.userKey, data.redirectUrl)
    //   .then((res) => {
    //     sessionStorage.setItem('CONPAY_BRAND_INFO', JSON.stringify(brandInfo));
    //     sessionStorage.setItem('CONPAY_USER_KEY', data.userKey);
    //     sessionStorage.setItem('CONPAY_USER_EMAIL', data.userEmail || '');
    //     sessionStorage.setItem('CONPAY_REDIRECT_URL', data.redirectUrl);
    //     sessionStorage.setItem(
    //       'CONPAY_CUSTOMIZE_OPTION',
    //       JSON.stringify(data.style)
    //     );
    //   })
    //   .catch((e) => console.log(e));
  };

  // 커넥트페이관리
  settings = (data = {}) => {
    pushRouter(data, null, routes.settings.hashPath, () => {
      setDisableBackControl();
    });
  };

  // 결제수단관리
  payMethod = (data = {}) => {
    pushRouter(data, null, routes.payMethod.hashPath, () => {
      setDisableBackControl();
    });
  };

  // 온라인결제
  onlinePay = (data = {}) => {
    return new Promise((resolve, reject) => {
      setReturnPromiseForBrand(resolve, reject);
      pushRouter(data, null, routes.onlinePay.hashPath, () => {
        setDisableBackControl();
      });
    });
  };

  // 현장결제
  onsitePay = (data = {}) => {
    pushRouter(data, null, routes.onsitePay.hashPath, () => {
      setDisableBackControl();
    });
  };

  // 현금영수증 설정
  cashReceipt = (data = {}) => {
    pushRouter(data, null, routes.cashReceipt.hashPath, () => {
      setDisableBackControl();
    });
  };

  // 충전머니 충전
  chargDeposit = (data = {}) => {
    return new Promise((resolve, reject) => {
      setReturnPromiseForBrand(resolve, reject);
      pushRouter(data, null, routes.chargDeposit.hashPath, () => {
        setDisableBackControl();
      });
    });
  };

  // 충전머니 자동충전
  chargDepositAuto = (data = {}) => {
    pushRouter(data, null, routes.chargDepositAuto.hashPath, () => {
      setDisableBackControl();
    });
  };

  // 충전머니 내역조회
  chargDetails = (data = {}) => {
    pushRouter(data, null, routes.chargDetails.hashPath, () => {
      setDisableBackControl();
    });
  };

  // 결제 내역조회
  paymentDetails = (data = {}) => {
    pushRouter(data, null, routes.paymentDetails.hashPath, () => {
      setDisableBackControl();
    });
  };

  // 약관동의
  terms = (data = {}) => {
    pushRouter(data, null, routes.terms.hashPath, () => {
      setDisableBackControl();
    });
  };

  // 계좌등록
  accountRegi = (data = {}) => {
    pushRouter(data, null, routes.accountRegi.hashPath, () => {
      setDisableBackControl();
    });
  };

  // 카드등록
  cardRegi = (data = {}) => {
    pushRouter(data, null, routes.cardRegi.hashPath, () => {
      setDisableBackControl();
    });
  };

  // 결제비밀번호
  enterPwd = (data = {}) => {
    pushRouter(data, null, routes.enterPwd.hashPath, () => {
      setDisableBackControl();
    });
  };

  // 계좌송금
  accountRemitc = (data = {}) => {
    return new Promise((resolve, reject) => {
      setReturnPromiseForBrand(resolve, reject);
      pushRouter(data, null, routes.accountRemitc.hashPath, () => {
        setDisableBackControl();
      });
    });
  };

  // 충전머니 송금
  chargRemitc = (data = {}) => {
    return new Promise((resolve, reject) => {
      setReturnPromiseForBrand(resolve, reject);
      pushRouter(data, null, routes.chargRemitc.hashPath, () => {
        setDisableBackControl();
      });
    });
  };

  // 충전머니 송금 (머니to머니)
  chargRemitcUid = (data = {}) => {
    return new Promise((resolve, reject) => {
      setReturnPromiseForBrand(resolve, reject);
      pushRouter(data, null, routes.chargRemitcUid.hashPath, () => {
        setDisableBackControl();
      });
    });
  };
}

export default Conpay;
